import { createStore } from 'vuex';

interface User {
  id: number;
  name: string;
  email: string;
  role: string;
  created_at: string;
}

interface State {
  api_url: string;
  authenticated: boolean;
  user: User | null; // Correction du type
  membership: null;
  token: string;
  notificationCount: number;
}

interface AuthPayload {
  user: User;
  token: string;
}

export default createStore({
  state: {
    // api_url: 'http://localhost:9090',
    api_url: 'https://asdecode.com',
    authenticated: false,
    token: '',
    notificationCount: 0,
    user: null,
    membership: null
  } as State,

  getters: {
    apiUrl: (state: State) => state.api_url,
    user: (state: State) => state.user,
    membership: (state: State) => state.membership,
    authenticated: (state: State) => state.authenticated,
    notificationCount: (state: State) => state.notificationCount,
  },

  mutations: {
    setUser(state: State, user: User) {
      if (state.user) {
        state.user.name = user.name;
        state.user.email = user.email

        const userDatas = {
          user: state.user,
          token: state.token
        }
        window.localStorage.setItem('panel_freelance_asdecode', JSON.stringify(userDatas))
      }
    },
    setAuthenticated(state: State, payload: AuthPayload) {
      state.user = payload.user;
      state.token = payload.token;
      state.authenticated = true;

      const userDatas = {
        user: payload.user,
        token: payload.token,
      };
      window.localStorage.setItem('panel_freelance_asdecode', JSON.stringify(userDatas));
    },
    setMembership(state: State, payload: any) {
      state.membership = payload;
      window.localStorage.setItem('profil_asdecode', JSON.stringify(state.membership));
    },

    // setUserPhoto(state: State, photo: string) {
    //   if (state.user) {
    //     state.user.photo = photo;
    //   }

    //   const userDatas = {
    //     user: state.user,
    //     token: state.token,
    //   };
    //   window.localStorage.setItem('panel_freelance_asdecode', JSON.stringify(userDatas));
    // },

    clearUserData(state: State) {
      state.authenticated = false;
      state.user = null;
      state.token = '';
      window.localStorage.removeItem('panel_freelance_asdecode');
      window.localStorage.removeItem('profil_asdecode');
    },

    setNotifications(state: State, nb: number) {
      state.notificationCount = nb;
    },
  },

  actions: {

  },

  modules: {},
});
